var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-alert",
        {
          staticClass: "intro",
          attrs: { type: "info", closable: false, "show-icon": "" },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("appleNotif.introTitle"))),
          ]),
          _c("div", { staticClass: "intro-body" }, [
            _vm._v(_vm._s(_vm.$t("appleNotif.introBody"))),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "170px" },
              model: {
                value: _vm.query.hours,
                callback: function ($$v) {
                  _vm.$set(_vm.query, "hours", $$v)
                },
                expression: "query.hours",
              },
            },
            _vm._l(_vm.hourOptions, function (h) {
              return _c("el-option", {
                key: h,
                attrs: {
                  label: _vm.$t("appleNotif.lastHours", { h: h }),
                  value: h,
                },
              })
            }),
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: {
                type: "primary",
                icon: "el-icon-search",
                loading: _vm.loading,
              },
              on: {
                click: function ($event) {
                  return _vm.runAudit(false)
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("appleNotif.check")) + " ")]
          ),
          _vm.result && _vm.result.summary.missing > 0
            ? _c(
                "el-button",
                {
                  staticClass: "filter-item",
                  attrs: {
                    type: "warning",
                    icon: "el-icon-refresh",
                    loading: _vm.loading,
                  },
                  on: { click: _vm.confirmReplay },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("appleNotif.replayMissing", {
                          n: _vm.result.summary.missing,
                        })
                      ) +
                      " "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.result
        ? _c(
            "div",
            { staticClass: "stats-row" },
            [
              _c("el-card", { staticClass: "stat-card" }, [
                _c("div", { staticClass: "stat-label" }, [
                  _vm._v(_vm._s(_vm.$t("appleNotif.statSent"))),
                ]),
                _c("div", { staticClass: "stat-value" }, [
                  _vm._v(_vm._s(_vm.result.summary.fromApple)),
                ]),
              ]),
              _c("el-card", { staticClass: "stat-card" }, [
                _c("div", { staticClass: "stat-label" }, [
                  _vm._v(_vm._s(_vm.$t("appleNotif.statProcessed"))),
                ]),
                _c("div", { staticClass: "stat-value ok" }, [
                  _vm._v(_vm._s(_vm.result.summary.processed)),
                ]),
              ]),
              _c("el-card", { staticClass: "stat-card" }, [
                _c("div", { staticClass: "stat-label" }, [
                  _vm._v(_vm._s(_vm.$t("appleNotif.statMissing"))),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "stat-value",
                    class: _vm.result.summary.missing > 0 ? "bad" : "ok",
                  },
                  [_vm._v(" " + _vm._s(_vm.result.summary.missing) + " ")]
                ),
              ]),
              _c("el-card", { staticClass: "stat-card" }, [
                _c("div", { staticClass: "stat-label" }, [
                  _vm._v(_vm._s(_vm.$t("appleNotif.statReplayed"))),
                ]),
                _c("div", { staticClass: "stat-value" }, [
                  _vm._v(_vm._s(_vm.result.summary.replayed)),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.result
        ? _c("div", { staticClass: "window-line" }, [
            _vm._v(
              " " +
                _vm._s(_vm.result.environment) +
                " · " +
                _vm._s(_vm.formatDate(_vm.result.window.startDate)) +
                " - " +
                _vm._s(_vm.formatDate(_vm.result.window.endDate)) +
                " "
            ),
          ])
        : _vm._e(),
      _vm.result
        ? _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.result.items,
                border: "",
                fit: "",
                size: "small",
                "row-class-name": _vm.rowClass,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("appleNotif.colStatus"),
                  width: "110",
                  align: "center",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: row.processed ? "success" : "danger",
                                size: "mini",
                                effect: "dark",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    row.processed
                                      ? _vm.$t("appleNotif.processed")
                                      : _vm.$t("appleNotif.missing")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2404104597
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("appleNotif.colNotification"),
                  "min-width": "230",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("div", { staticClass: "type" }, [
                            _vm._v(_vm._s(row.notificationType || "-")),
                          ]),
                          row.subtype
                            ? _c("div", { staticClass: "subtype" }, [
                                _vm._v(_vm._s(row.subtype)),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1419540117
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("appleNotif.colProduct"),
                  "min-width": "220",
                  prop: "productId",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("appleNotif.colTransaction"),
                  "min-width": "180",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("span", { staticClass: "mono" }, [
                            _vm._v(_vm._s(row.originalTransactionId || "-")),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2047325820
                ),
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("appleNotif.colSentAt"), width: "180" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [_vm._v(_vm._s(_vm.formatDate(row.signedDate)))]
                      },
                    },
                  ],
                  null,
                  false,
                  1794726799
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("appleNotif.colFirstAttempt"),
                  width: "120",
                  align: "center",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "span",
                            {
                              class:
                                row.firstSendAttemptResult === "SUCCESS"
                                  ? "ok"
                                  : "bad",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(row.firstSendAttemptResult || "-") +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3535085387
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("appleNotif.colReplay"),
                  "min-width": "200",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          !row.replay
                            ? _c("span", [_vm._v("-")])
                            : [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: _vm.replayTagType(
                                        row.replay.outcome
                                      ),
                                      size: "mini",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.replayLabel(row.replay.outcome)
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                row.replay.reason
                                  ? _c("div", { staticClass: "reason" }, [
                                      _vm._v(_vm._s(row.replay.reason)),
                                    ])
                                  : _vm._e(),
                              ],
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  4235222848
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.result && !_vm.result.items.length
        ? _c("el-empty", {
            attrs: { description: _vm.$t("appleNotif.emptyWindow") },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }